import React from 'react';

import styled from 'styled-components';

import { Link, Stack, SvgIcon, Typography } from 'components';

import { ContactSupportButton } from './ContactSupport/ContactSupportButton';

import { useTranslation } from 'third-party';

const Content = styled(Stack)`
  padding: 1.2rem;
  gap: 0.8rem;
  border-top: 1px solid ${props => props.theme.custom.palette.muted100};
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const Label = styled(Typography)`
  color: ${props => props.theme.custom.palette.darkText};
  font-weight: 600;
`;

const StyledLink = styled(Link)`
  display: flex;
  flex-direction: row;
  gap: 0.4rem;
  margin-left: auto;
  align-items: center;
`;

const LinkText = styled(Typography)`
  color: ${props => props.theme.custom.palette.secondary500};
  text-transform: uppercase;
  font-size: 1.4rem;
  font-weight: 900;
`;

export const DIALOG_ITEM_HEIGHT = 85;
export const CONTRACTOR_DIALOG_ITEM_HEIGHT = 65;

type HelpCenterFooterProps = {
  showNextArticleLink?: boolean;
  onNextArticleClick?: () => void;
  nextArticleTitle?: string;
};

export const HelpCenterFooter = ({
  showNextArticleLink,
  onNextArticleClick,
  nextArticleTitle = '',
}: HelpCenterFooterProps) => {
  const { t } = useTranslation();

  return (
    <Content>
      {showNextArticleLink ? (
        <StyledLink onClick={onNextArticleClick}>
          <LinkText>
            {t('helpCenter.panel.nextArticleLink', { title: nextArticleTitle })}
          </LinkText>
          <SvgIcon height="1.2rem" width="0.74rem" icon="shevron-right" />
        </StyledLink>
      ) : (
        <>
          <Label variant="body2">{t('helpCenter.panel.supportLabel')}</Label>
          <ContactSupportButton />
        </>
      )}
    </Content>
  );
};
